module.exports = __webpack_public_path__ + "static/media/Icon_tag.fd6b70dc.svg";